import React from "react";

interface LoadingSpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: "sm" | "md" | "lg";
  color?: "primary" | "white" | "muted";
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  color = "primary",
  message,
  className = "",
  ...props
}) => {
  const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-8 w-8 border-2",
    lg: "h-12 w-12 border-4",
  };

  const colorClasses = {
    primary:
      "border-t-red-600 border-r-red-600 border-b-transparent border-l-transparent",
    white:
      "border-t-white border-r-white border-b-transparent border-l-transparent",
    muted:
      "border-t-gray-400 border-r-gray-400 border-b-transparent border-l-transparent",
  };

  return (
    <div className="flex flex-col items-center space-y-3">
      <div
        className={`inline-block animate-spin rounded-full ${sizeClasses[size]} ${colorClasses[color]} ${className}`.trim()}
        role="status"
        aria-label={message || "Loading"}
        {...props}
      >
        <span className="sr-only">Loading...</span>
      </div>
      {message ? <p className="text-gray-600">{message}</p> : null}
    </div>
  );
};

export const LoadingPage: React.FC<Omit<LoadingSpinnerProps, "size">> = ({
  color = "primary",
  message,
  className,
  ...props
}) => (
  <div className="min-h-screen flex items-center justify-center">
    <LoadingSpinner
      size="lg"
      color={color}
      message={message}
      className={className}
      {...props}
    />
  </div>
);

export default LoadingSpinner;
